module.exports = __webpack_public_path__ + "static/media/internet.5fd2e804.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skywire/images/internet.svg
// module id = 1139
// module chunks = 0